import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SystemApp } from '../constans/SystemConfigurations';
import { ApiUrl } from '../shared/models/apiurl.models';

export interface LegalDocument {
  id: number;
  title: string;
  content: string;
  version: string;
  effective_date: string | null;
  updated_at: string;
}

@Injectable({
  providedIn: 'root'
})
export class LegalService {

  private get options() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': this.apiKey.getJWTToken()
      })
    };
  }

  constructor(private http: HttpClient, private apiKey: ApiUrl) {}

  getPrivacyPolicy(): Observable<LegalDocument> {
    return this.http.get<LegalDocument>(
      `${SystemApp.base_url_api}/company-api/privacy/info/`,
      this.options
    );
  }

  getTermsConditions(): Observable<LegalDocument> {
    return this.http.get<LegalDocument>(
      `${SystemApp.base_url_api}/company-api/terms/info/`,
      this.options
    );
  }
}
